// Functions
import VerifyToken from "../../config/verifyToken";
import useReportAccess from "../../config/useReportAccess";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import ReportsView from "../../components/reports";

const Reports = () => {
  useReportAccess("PROTOCOL_REPORT");

  return (
    <>
      {VerifyToken()}
      <Header />
      <Main>
        <StickyLogo />
        <ReportsView />
      </Main>
    </>
  );
};

export default Reports;
